import { MfaActionTypes } from "./mfaTypes"

export const requestMfaSmsAction = () => (
  {
    type: MfaActionTypes.REQUEST_SMS_ASYNC_PENDING
  }
)
